import { useCallback } from 'react'

import { useHistory } from 'react-router-dom'

import TransmissionService from 'modules/transmission/service'
import { useTransmissionContext } from '../context'

export default function useFetchTransmission() {
  const history = useHistory()

  const { setLoading, setTransmissionData, transmissionCode } = useTransmissionContext()

  const fetchTransmission = useCallback(async (): Promise<void> => {
    if (!transmissionCode) {
      return
    }

    setLoading(true)

    if (transmissionCode === '404') {
      history.push('/404')
      return
    }

    try {
      const transmissionInfo = await TransmissionService.getTransmissionInfo(transmissionCode)

      document.title = `Hotmart Webinar - ${transmissionInfo.name}`

      setTransmissionData(transmissionInfo)
      setLoading(false)
    } catch (error) {
      console.error(error)
      history.push('/404')
    }
  }, [history, transmissionCode, setLoading, setTransmissionData])

  return fetchTransmission
}
